import * as React from "react";
import {useState} from "react";
import {MuiFileInput} from "mui-file-input";
import {prepareUploadAdhocImage, uploadImage} from "../service/ImageService";
import {Alert, ProgressBar} from "react-bootstrap";


export default function AdhocImageUpload(props) {
    const { images, setImages} = props;
    const [isUploading, setIsUploading] = useState(false)
    const [uploadPercentage, setUploadPercentage] = useState(0);



    const [files, setFiles] = useState(null);

    function delayOneSecond() {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 1000); // 1000 milliseconds = 1 second
        });
    }

    const handleUpload = async (newValue) => {
        let pendingImages = [];
        const progressArray = new Array(newValue.length).fill(0); // Initialize progress array

        setIsUploading(true);

        setFiles(newValue);

        const updateTotalProgress = () => {
            const totalProgress = progressArray.reduce((acc, curr) => acc + curr, 0) / newValue.length;
            const totalProgressRounded = Number(totalProgress.toFixed(2));
            setUploadPercentage(totalProgressRounded);
        };

        await Promise.all(newValue.map(async (file, index) => {
            const fileType = file?.type?.split("/")[1]?.toLowerCase() || "unknown";
            const fileName = file?.name || "unknown";

            await prepareUploadAdhocImage(fileName, fileType).then(async (response) => {
                if (response.status === 200) {
                    let data = await response.json();
                    let signedUrl = data.upload_url;

                    await uploadImage(signedUrl, file, (percentage) => {
                        progressArray[index] = percentage; // Update this file's progress
                        updateTotalProgress(); // Update total progress
                    });

                    pendingImages.push(data);
                } else {
                    console.error(response);
                }
            });
        }));

        setFiles(null);
        setIsUploading(false);
        setUploadPercentage(0)
        delayOneSecond().then(() => {
            setImages([...images, ...pendingImages]);
        });
    };


    return (

        <>
            <MuiFileInput
                sx={{mt: 1}}
                type="file"
                inputProps={{accept: "image/*, video/*, application/pdf"}}
                placeholder="Click to Insert your images"
                multiple
                disabled={isUploading}
                value={files}
                onChange={handleUpload}
                fullWidth={true}
                size={'small'}
            />
            {isUploading && <div>
                <Alert key={"primary"} variant={"primary"}>
                    <ProgressBar animated now={uploadPercentage} label={`${uploadPercentage}%`}/>
                    Uploading...Please wait
                </Alert>
                 </div>

            }
        </>

    )
}
